import { useState } from "react";
import { toast } from "sonner";
import { CloudDownload, CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { saveBooksOffline } from "@/lib/offline";

// One button above the library: saves every book of the student's level for offline reading.
export const SaveLevelButton = ({ books, savedIds, onSaved, online }) => {
  const { t } = useLang();
  const [pct, setPct] = useState(null);
  const savedN = books.filter((b) => savedIds.has(b.id)).length;
  const allSaved = books.length > 0 && savedN === books.length;

  const save = async () => {
    if (!books.length) { toast.info(t.lib.saveNone); return; }
    setPct(0);
    try {
      await saveBooksOffline(books, setPct);
      toast.success(t.lib.savedAll(books.length));
    } catch {
      toast.error(t.lib.saveFailed);
    } finally {
      setPct(null);
      onSaved?.();
    }
  };

  return (
    <div className="mt-8 flex flex-wrap items-center gap-3" data-testid="save-level-panel">
      <button onClick={save} disabled={pct !== null || !online} data-testid="save-level-btn"
        className="inline-flex items-center gap-2 rounded-full bg-[#047857] text-white px-6 py-3 font-semibold hover:bg-[#065F46] transition-colors disabled:opacity-60">
        {allSaved && pct === null ? <CheckCircle2 className="w-5 h-5" /> : <CloudDownload className="w-5 h-5" />}
        {pct !== null ? t.lib.saving(pct) : t.lib.saveLevel}
      </button>
      <span className="text-sm text-stone-600" data-testid="save-level-status">
        {books.length ? t.lib.savedCount(savedN, books.length) : t.lib.saveNone} · {t.lib.saveHint}
      </span>
    </div>
  );
};
